// TODO: 2024 november, remove this.
const migratedBlogPostSlugs = [
  'benefits-of-group-learning',
  'about',
  'team-spotlight-joy',
  'update-2021-august-30',
  'update-2023-april-10',
  'free-online-math-tutoring-sessions',
  'update-2023-march-13',
  'team-spotlight-varun',
  'update-2021-september-06',
  'update-2023-february-06',
  'team-spotlight-karen',
  'reflections-high-school',
  'how-to-survive-ap-calculus',
  'khan-academy-meets-wikipedia',
  "introduction-to-newton's-laws-of-motion",
  'benefits-of-becoming-a-tutor',
  'guide-to-the-sat',
  'update-2021-october-04',
  'anisa-candid-reflections-on-shw',
  'common-misconceptions-in-newtonian-physics',
  'school-kids-mental-health',
  'update-2022-april-04',
  'give-chess-a-chance',
  'update-2023-march-06',
  'easy-scholarships-2022',
  'update-2021-october-25',
  'announcing-schoolhouse-points',
  'volunteer-opportunities-for-teens',
  'volunteer-tutoring-at-schoolhouse',
  'spotify-study-playlists',
  'update-2021-december-27',
  'update-2021-december-13',
  'strategies-for-staying-motivated',
  "the-survivor's-guide-to-online-learning",
  'math-tutor-live-help',
  'team-spotlight-nima',
  'the-chemistry-behind-tie-dye',
  'future-of-medicine',
  'team-spotlight-mariah',
  'sal-khan-interview',
  'why-is-calculus-so-hard',
  'update-2022-february-14',
  'update-2022-june-13',
  'when-it-rains-outside',
  'team-spotlight-kate',
  'schoolhouse-summer-camp',
  'science-of-learning',
  'update-2022-august-22',
  'update-2021-august-23',
  'intern-spotlight-viraj',
  'overwhelmed-by-slack',
  'tutor-tips-on-managing-study-time-effectively',
  'team-spotlight-drew',
  'how-to-get-into-college',
  'team-spotlight-elysa',
  'update-2022-october-03',
  'the-power-of-peer-tutoring',
  'update-2023-april-24',
  'hacking-schoolhouse-aka-building-cool-things',
  'balancing-life-in-high-school',
  'sat-math-practice-test',
  'cultural-blending',
  'time-tracking-for-beginners',
  'arpit-team-spotlight',
  'navratri',
  'christy-internship',
  'stop-procrastinating',
  'update-2022-june-27',
  'productivity-hacks-for-second-semester-2022',
  'advice-for-high-school-students-from-the-class-of-22',
  'resources-for-shw-tutors',
  'live-math-tutor',
  'the-meaning-of-community-at-shw',
  'college-for-success',
  'embracing-cameras-off-in-a-virtual-classroom',
  'english-proficiency-exams-for-students',
  'multi-million-dollar-donation-citadel-and-securities',
  'intern-spotlight-jennifer',
  'update-2022-october-10',
  'update-2022-march-21',
  'step-in',
  'a-note-on-ukraine',
  'update-2022-april-11',
  'intrepided-value-of-peer-tutoring',
  'my-journey-on-shw',
  'tutor-trees',
  'tailored-sessions-to-learn-algebra',
  'dealing-with-the-residual-effects-of-the-pandemic-on-educational-inequality',
  'guide-to-sat',
  'tips-to-be-a-better-tutor',
  'synthesia-the-fusion-of-senses',
  'welcome-alyssa-vigil',
  'learners-guide-toschoolhouse',
  'update-2021-august-02',
  'update-2022-august-15',
  'update-2021-july-26',
  'real-world-applications-of-math',
  'introducing-live-help-india',
  'schoolhouse-catching-up',
  'math-usefulness-elegance',
  'hard-easy-subjects',
  'india-team-spotlight-hafsah-m',
  'team-spotlight-kareena',
  'ap-exams-worth',
  'update-2021-october-11',
  'update-2021-october-18',
  'update-2021-november-29',
  'how-to-get-ahead-over-the-summer',
  'mendelian-genetics',
  'save-da-globe-with-the-sdgs',
  'an-overview-of-the-digital-sat',
  'update-2022-december-21',
  'zoom-fatigue',
  'team-spotlight-matt',
  'reflections-on-tutoring',
  'having-fun-with-fibonacci',
  'math-applications',
  'emerging-medical-technologies',
  'summer-writing-club-showcase',
  'update-2022-april-18',
  'mathematical-finance-valuable-major-math-students',
  'update-2021-august-16',
  'update-2022-september-19',
  'update-2022-october-24',
  'think-big-start-small',
  'update-2022-may-09',
  'joy-of-anatomy',
  'test-anxiety-tips',
  'psychology-in-medicine',
  'update-2023-january-16',
  'update-2022-november-28',
  'calculus-interpretation-of-geometry',
  'tips-for-new-tutors',
  'the-benefits-of-virtual-learning',
  'update-2022-october-31',
  'update-2023-january-10',
  'an-inside-look-into-schoolhouse',
  'uranium-in-my-cupboard',
  'importance-of-curiosity',
  'uplift-each-other',
  'learning-to-code',
  'introduction-to-coding',
  'importance-of-feedback',
  'update-2022-may-30',
  'guide-to-AP-exams',
  'always-be-a-learner',
  'waves-from-visuals-to-equations',
  'combatting-burnout-in-an-academic-setting',
  'update-2021-september-20',
  'environmental-health-and-medicine',
  'update-2023-april-17',
  'stop-just-learning',
  'pediatrics-and-saving-lives',
  'stem-cell-technology-in-medicine',
  'indispensable-and-replaceable',
  'five-unexpected-computer-science-careers',
  'update-2023-january-30',
  'how-to-set-goals',
  'why-math-is-easy',
  'challenges-in-high-school',
  'human-tutors-backed-by-ai',
  'update-2021-november-01',
  'community-engagment-schoolhouse',
  'will-AI-replace-tutors',
  'update-2023-february-27',
  'best-programming-languages-to-learn-in-2023',
  'update-2022-june-20',
  'power-of-believing-in-yourself',
  'how-to-write-better-essays',
  'how-to-learn-a-language',
  'finding-your-voice',
  'update-2022-may-16',
  'science-of-sleep',
  'best-ways-to-support-the-lgbtq-community-this-pride-month',
  'exploring-life-at-the-cellular-level-and-why-it-matters',
  'ten-minute-guide-to-symbolism',
  'digital-sat',
  'the-diamond-tutor',
  'update-2021-november-08',
  'update-2022-february-07',
  'the-two-secrets-of-schoolhouse-hiring',
  'update-2022-january-03',
  'update-2023-march-27',
  'update-2021-september-13',
  'update-2021-december-06',
  'update-2022-february-21',
  'update-2022-january-10',
  'update-2022-july-18',
  'update-2023-april-03',
  'update-2021-november-15',
  'update-2021-december-20',
  'update-2022-december-12',
  'update-2022-may-23',
  'update-2022-december-05',
  'update-2023-february-20',
  'update-2022-august-08',
  'update-2022-october-17',
  'update-2022-march-28',
  'update-2022-july-25',
  'update-2022-september-26',
  'update-2022-september-12',
  'update-2022-november-07',
  'update-2022-april-25',
  'update-2023-february-13',
  'update-2023-march-20',
  'update-2023-may-08',
  'update-2021-july-19',
  'update-2021-august-09',
  'update-2022-february-28',
  'update-2023-may-01',
  'update-2021-september-27',
  'update-2022-january-17',
  'update-2021-november-22',
  'update-2022-january-24',
  'update-2022-march-14',
  'update-2022-january-31',
  'update-2022-november-21',
  'update-2023-january-23',
  'update-2022-july-04',
  'update-2022-july-11',
  'update-2022-september-05',
  'update-2022-may-02',
  'update-2022-august-01',
  'update-2022-november-15',
  'update-2022-march-07',
  'update-2022-august-29',
]

// Trust & privacy constants
const COOKIE_POLICY_URL =
  'https://docs.google.com/document/d/e/2PACX-1vQiYGZ3SI5elOb_jrFO7fx_PmKkaZedh-2LigPmsXgqLCMCVGoABjq0gss9FjLBv6zgf_LohUjbHyTF/pub'
const THIRD_PARTY_PROVIDERS_URL =
  'https://docs.google.com/document/d/e/2PACX-1vQhl72_YlVnSpWh6kr1oSTLSkHsE_ZPnix40YpMCiT75Q2GEXoTqG7kFL79GRPHzrVTEf1w5tJ5Egm9/pub'
const TERMS_DEFINITIONS_URL =
  'https://docs.google.com/document/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub'
const SAFETY_ARTICLE = 'https://schoolhouse.world/faq/en/articles/9959293-safety-at-schoolhouse'
const SESSION_CONTENT_ARTICLE =
  'https://schoolhouse.world/faq/en/articles/9967479-what-content-can-schoolhouse-sessions-cover'
const COMMUNITY_GUIDELINES_ARTICLE =
  'https://schoolhouse.world/faq/en/articles/9967517-schoolhouse-world-community-guidelines'
const CANNY_BUGS_URL = 'https://schoolhouse.canny.io/bugs'

// Warning! Not all of these redirects are working as of Aug 29, 2024. The Nextjs implementation of redirects
// is not working and we have implemented a hack in the getRedirect() function that is called by the
// <ShwLink /> component. This hack will be removed once we figure how to resume using Nextjs redirects.
// In paricular, the wildcard path parameter is not working correctly in our solution.
//
// If you add any new redirects, you must add tests to the `getRedirect.test.ts` file to test them.
export const REDIRECTS = [
  {
    source: '/assets/:path*',
    destination: 'https://assets.schoolhouse.world/:path*',
    permanent: false,
  },
  {
    source: '/avatars/:path*',
    destination: 'https://avatars.schoolhouse.world/:path*',
    permanent: false,
  },
  // ^ This assets redirect is only for localhost
  // In production, we use Cloudflare rewrites to send these requests
  // to S3 directly.
  {
    source: '/transcript/t/:id',
    destination: 'https://schoolhouse-transcript.world/t/:id',
    permanent: false,
  },
  {
    source: '/tutors/:id',
    destination: '/tutor/:id',
    permanent: false,
  },
  {
    source: '/tutor/:id(\\d{1,})',
    destination: '/u/:id',
    permanent: false,
  },
  {
    source: '/tutor/:id(\\d{1,})/network',
    destination: '/u/:id/network',
    permanent: false,
  },
  {
    source: '/topic/review/:id(\\d{1,})',
    destination: '/certification/review/:id',
    permanent: false,
  },
  {
    source: '/certification',
    destination: '/certification/about',
    permanent: false,
  },
  {
    source: '/donate',
    destination: 'https://schoolhouseworld.networkforgood.com/',
    permanent: false,
  },
  {
    source: '/readyset',
    destination: '/',
    permanent: false,
  },
  {
    source: '/roadmap',
    destination: 'https://coda.io/@shw/shw-roadmap',
    permanent: false,
  },
  {
    source: '/ap',
    destination: '/',
    permanent: false,
  },
  {
    source: '/india',
    destination: '/course/india',
    permanent: false,
  },
  {
    source: '/summer',
    destination: '/',
    permanent: false,
  },
  // Session Reminder Text
  {
    source: '/r/t/:id',
    destination: '/session/:id\\?utm_medium=sms&utm_campaign=session_reminder',
    permanent: false,
  },
  {
    source: '/r/ts/:id',
    destination: '/series/:id\\?utm_medium=sms&utm_campaign=session_reminder',
    permanent: false,
  },
  {
    // Live Help session reminder text
    source: '/r/tlh',
    destination: '/live-help\\?utm_medium=sms&utm_campaign=session_reminder',
    permanent: false,
  },
  {
    // Doubt Clearing session reminder text
    source: '/r/tdc',
    destination: '/doubt-clearing\\?utm_medium=sms&utm_campaign=session_reminder',
    permanent: false,
  },
  // NOTE: This is temporary, remove this a few weeks later
  // Current Timestamp: 22nd June 2021
  {
    source: '/about/get-involved',
    destination: '/',
    permanent: false,
  },
  {
    source: '/livehelp',
    destination: '/live-help',
    permanent: false,
  },
  {
    source: '/live-help/educators',
    destination: '/teachers',
    permanent: false,
  },
  {
    source: '/join/key-club',
    destination: '/key-club',
    permanent: false,
  },
  {
    source: '/college-pioneer',
    destination: 'https://form.typeform.com/to/gMdu1QF7',
    permanent: false,
  },
  {
    source: '/college-partner',
    destination: 'https://forms.gle/ETLC3CKYNcGddSgP6',
    permanent: false,
  },
  {
    source: '/about/cookies',
    destination: COOKIE_POLICY_URL,
    permanent: false,
  },
  {
    source: '/about/terms-definitions',
    destination: TERMS_DEFINITIONS_URL,
    permanent: false,
  },
  {
    source: '/about/third-parties',
    destination: THIRD_PARTY_PROVIDERS_URL,
    permanent: false,
  },
  {
    source: '/classrooms/:id',
    destination: '/classrooms/:id/certifications',
    permanent: false,
  },
  {
    source: '/about/safety',
    destination: SAFETY_ARTICLE,
    permanent: false,
  },
  {
    source: '/about/content-policy',
    destination: SESSION_CONTENT_ARTICLE,
    permanent: false,
  },
  {
    source: '/about/community-guidelines',
    destination: COMMUNITY_GUIDELINES_ARTICLE,
    permanent: false,
  },
  {
    source: '/sat-bootcamp-coming-soon',
    destination: '/sat-bootcamp/coming-soon',
    permanent: false,
  },
  {
    source: '/sat-bootcamp/coming-soon',
    destination: '/sat-bootcamp',
    permanent: false,
  },
  // We changed this route before we started sending to learners, so we know
  // if anyone visits this route they are giving tutor consent.
  {
    source: '/sat-bootcamp/consent/:invite_code',
    destination: '/sat-bootcamp/tutor/consent\\?invite_code=:invite_code',
    permanent: false,
  },
  {
    source: '/sat-bootcamp/request-consent/tutor',
    destination: '/sat-bootcamp/tutor/request-consent',
    permanent: false,
  },
  // So we don't have to handle sat-bootcamp as a separate case
  // when linking to course pages.
  {
    source: '/course/sat-bootcamp-math',
    destination: '/w/sat-bootcamp',
    permanent: false,
  },
  {
    source: '/course/sat-bootcamp-reading-writing',
    destination: '/w/sat-bootcamp',
    permanent: false,
  },
  // 'audit' -> 'peer review'
  {
    source: '/admin/audit',
    destination: '/admin/peer-review',
    permanent: true,
  },
  {
    source: '/admin/audit/:subpath',
    destination: '/admin/peer-review/:subpath',
    permanent: true,
  },
  {
    source: '/admin/peer-review/audits',
    destination: '/admin/peer-review/reviews',
    permanent: true,
  },
  {
    source: '/tutor/audit',
    destination: '/tutor/peer-review',
    permanent: true,
  },
  {
    source: '/tutor/audit/:subpath',
    destination: '/tutor/peer-review/:subpath',
    permanent: true,
  },
  {
    source: '/live-help/doubt-clearing',
    destination: '/live-help',
    permanent: true,
  },
  {
    source: '/dashboard/tutoring',
    destination: '/dashboard',
    permanent: false,
  },
  {
    source: '/beta/w/:worldSlug/c/:channelId/p/:postId',
    destination: '/beta/w/:worldSlug/p/:postId',
    permanent: false,
  },
  {
    source: '/explore/all',
    destination: '/explore',
    permanent: true,
  },
  {
    source: '/beta',
    destination: '/',
    permanent: true,
  },
  {
    source: '/beta/:path*',
    destination: '/:path*',
    permanent: true,
  },
  {
    source: '/sat-bootcamp/explore',
    destination: '/w/sat-bootcamp/sessions\\?show=explore',
    permanent: false,
  },
  {
    source: '/tutor/host',
    destination: '/tutor',
    permanent: false,
  },
  {
    source: '/session/schedule',
    destination: '/tutor',
    permanent: false,
  },
  {
    source: '/series/schedule',
    destination: '/tutor',
    permanent: false,
  },
  {
    source: '/me/edit',
    destination: '/settings',
    permanent: false,
  },
  {
    source: '/me/edit/avatar',
    destination: '/settings',
    permanent: false,
  },
  {
    source: '/me/edit/notifications',
    destination: '/settings/notifications',
    permanent: false,
  },
  {
    source: '/sat',
    destination: '/sat-bootcamp',
    permanent: false,
  },
  {
    source: '/w/college-advice/:path*',
    destination: '/w/college-prep/:path*',
    permanent: false,
  },
  {
    source: '/w/sat-bootcamp/sessions',
    destination: '/w/sat-bootcamp',
    permanent: false,
  },
  {
    source: '/u/:user',
    has: [
      {
        type: 'query',
        key: 'show',
        value: 'achievements',
      },
    ],
    destination: '/u/:user/achievements',
    permanent: false,
  },
  {
    source: '/u/:user',
    has: [
      {
        type: 'query',
        key: 'show',
        value: 'sessions',
      },
    ],
    destination: '/u/:user/sessions',
    permanent: false,
  },
  {
    source: '/u/:user',
    has: [
      {
        type: 'query',
        key: 'show',
        value: 'feedback',
      },
    ],
    destination: '/u/:user/feedback',
    permanent: false,
  },
  {
    source: '/u/:user',
    has: [
      {
        type: 'query',
        key: 'show',
        value: 'overview',
      },
    ],
    destination: '/u/:user',
    permanent: false,
  },
  {
    source: '/sat-bootcamp-onboarding-sessions',
    destination: '/sat-bootcamp/onboarding-sessions',
    permanent: false,
  },
  {
    source: '/sat-onboarding-sessions',
    destination: '/sat-bootcamp/onboarding-sessions',
    permanent: false,
  },
  {
    source: '/dashboard/achievements',
    destination: '/dashboard',
    permanent: false,
  },
  {
    source: '/dashboard/certifications',
    destination: '/dashboard',
    permanent: false,
  },
  {
    source: '/dashboard/new',
    destination: '/dashboard',
    permanent: false,
  },
  {
    source: '/dashboard/session',
    destination: '/dashboard',
    permanent: false,
  },
  ...migratedBlogPostSlugs.map(slug => ({
    source: `/blog/${slug}/`,
    destination: `/blog/${slug}`,
    permanent: true,
  })),
  {
    source: '/ka/:path*',
    destination: '/khan-academy/:path*',
    permanent: false,
  },
  {
    source: '/find-a-workshop',
    destination: '/find-a-program\\?world=college-admissions-workshops',
    permanent: false,
  },
  {
    source: '/find-a-bootcamp',
    destination: '/find-a-program\\?program=sat-bootcamp',
    permanent: false,
  },
  {
    source: '/dashboard/programs-new',
    destination: '/dashboard/programs',
    permanent: false,
  },
  {
    source: '/find-a-tutor',
    destination: '/dashboard/one-on-one',
    permanent: false,
  },
  {
    source: '/teachers',
    destination: '/educators',
    permanent: false,
  },
  {
    source: '/counselors',
    destination: '/educators',
    permanent: false,
  },
  {
    source: '/w/sat-bootcamp/schedule/series-template',
    destination: '/tutor\\?program=sat-bootcamp',
    permanent: false,
  },
  {
    source: '/w/sat/schedule/series-template',
    destination: '/tutor\\?subject=sat',
    permanent: false,
  },
  {
    source: '/w/college-admissions-workshops/schedule/series-template',
    destination: '/tutor\\?program=college-admissions-workshops',
    permanent: false,
  },
  {
    source: '/w/:worldSlug/schedule/series-template',
    destination: '/tutor',
    permanent: false,
  },
  {
    source: '/tutor/subject/:slug/certify',
    destination: '/tutor\\?subject=:slug&subpage=certify',
    permanent: true,
  },
  {
    source: '/tutor/program/:slug/certify',
    destination: '/tutor\\?program=:slug&subpage=certify',
    permanent: true,
  },
  {
    source: '/tutor/subject/:slug',
    destination: '/tutor\\?subject=:slug',
    permanent: true,
  },
  {
    source: '/tutor/program/:slug',
    destination: '/tutor\\?program=:slug',
    permanent: true,
  },
  // Redirect /w/:slug paths to /dashboard, except /w/:slug/schedule
  {
    source: '/w/:slug',
    destination: '/dashboard',
    permanent: false,
  },
  {
    source: '/w/:slug/:path((?!schedule).*)',
    destination: '/dashboard',
    permanent: false,
  },
  {
    source: '/explore',
    destination: '/',
    permanent: false,
  },
  {
    source: '/feedback/:path*',
    destination: CANNY_BUGS_URL,
    permanent: false,
  },
]
